var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 25,
    viewBox: "0 0 10 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0C6.72588 0 8.125 1.39912 8.125 3.125C8.125 4.85088 6.72588 6.25 5 6.25C3.27412 6.25 1.875 4.85088 1.875 3.125C1.875 1.39912 3.27412 0 5 0ZM7.34375 7.03125H6.78906C5.68013 7.54116 4.36768 7.56318 3.21094 7.03125H2.65625C1.36182 7.03125 0.3125 8.08057 0.3125 9.375V16.0156C0.3125 16.6628 0.837158 17.1875 1.48438 17.1875H2.26562V23.8281C2.26562 24.4753 2.79028 25 3.4375 25H6.5625C7.20972 25 7.73438 24.4753 7.73438 23.8281V17.1875H8.51562C9.16284 17.1875 9.6875 16.6628 9.6875 16.0156V9.375C9.6875 8.08057 8.63818 7.03125 7.34375 7.03125Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleIcon);
export default __webpack_public_path__ + "static/media/male-icon.68c2fbceb1125ae75cc4a2b5049bd136.svg";
export { ForwardRef as ReactComponent };